import React from 'react';
import { createRoot } from 'react-dom/client';
// Base tokens and primitives load first so component stylesheets can override them.
import './styles/theme.css';
import App from './App';
import { startAnalytics } from './analytics';

// Outside React so StrictMode's double-invoked effects cannot configure twice.
startAnalytics();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
